import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Loader from '../../components/Common/Loader';
import { verifyOtpService } from './services/verify-user.service';

const Verify = () => {
  const { token } = useParams();
  const navigateTo = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('idle');
  const [loading, setLoading] = useState<boolean>(true);

  const verifyOtp = async (): Promise<void> => {
    await verifyOtpService(token!, setVerificationStatus, setLoading, navigateTo);
  };

  useEffect(() => {
    if (token) {
      verifyOtp().then();
    }
  }, [token]);

  return (
    <div className="App">
      <NavigationBar />
      <div className="bg-storytan p-4 mx-auto">
        <div className="max-w-7xl mx-auto mt-11  sm:px-6 lg:px-8 min-h-screen text-3xl">
          {loading ? (
            <div className="m-auto w-full flex justify-center">
              <Loader loader={loading} />
            </div>
          ) : verificationStatus === 'success' && !loading ? (
            <>
              <div className="flex flex-col">
                <strong className="text-green-800">Your Account has been Verified Successfully!</strong>
                <span className="text-base mt-4">You will be redirect soon</span>
              </div>
            </>
          ) : !loading && verificationStatus === 'fail' ? (
            <strong className="text-red-800 text-bold">Verification failed due to Invalid OTP!</strong>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};
export default Verify;
